import { useEffect, useRef, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";

const FeatherSVG = () => (
  <svg viewBox="0 0 40 100" width="100%" height="100%">
    <path
      d="M20 3 C 33 28, 33 58, 22 95 L20 98 L18 95 C 7 58, 7 28, 20 3 Z"
      fill="rgba(255,255,255,0.72)"
    />
    <path d="M20 12 L11 30 M20 20 L31 34 M20 32 L10 50 M20 42 L31 56 M20 54 L11 70"
      stroke="rgba(255,255,255,0.4)" strokeWidth="0.7" fill="none" />
    <line x1="20" y1="8" x2="20" y2="95" stroke="rgba(255,255,255,0.55)" strokeWidth="0.9" />
  </svg>
);

function Feather({ id, onDone }) {
  const startX = 6 + Math.random() * 88; // vw
  const sway = 4 + Math.random() * 9;
  const dir = Math.random() > 0.5 ? 1 : -1;
  const dur = 15 + Math.random() * 10; // slow, weightless fall
  const size = 12 + Math.random() * 12;
  const rot = (Math.random() - 0.5) * 40;

  return (
    <motion.div
      aria-hidden
      initial={{ y: "-8vh", opacity: 0, rotate: rot }}
      animate={{
        y: "108vh",
        opacity: [0, 0.7, 0.7, 0],
        x: [
          `${startX}vw`,
          `${startX + sway * dir}vw`,
          `${startX - sway * dir}vw`,
          `${startX + sway * dir * 0.6}vw`,
        ],
        rotate: [rot, rot + 25 * dir, rot - 18 * dir, rot + 12 * dir],
      }}
      transition={{ duration: dur, ease: "easeInOut", times: [0, 0.2, 0.65, 1] }}
      onAnimationComplete={() => onDone(id)}
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        width: size,
        height: size * 2.4,
        zIndex: 57,
        filter: "blur(0.4px) drop-shadow(0 2px 6px rgba(255,255,255,0.25))",
        pointerEvents: "none",
      }}
    >
      <FeatherSVG />
    </motion.div>
  );
}

export default function Feathers() {
  const [list, setList] = useState([]);
  const idRef = useRef(0);

  useEffect(() => {
    if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return;
    let timer;
    const spawn = () => {
      const count = 1 + Math.floor(Math.random() * 2); // 1-2 feathers
      const batch = Array.from({ length: count }, () => {
        idRef.current += 1;
        return idRef.current;
      });
      setList((l) => (l.length > 2 ? l : [...l, ...batch]));
      timer = setTimeout(spawn, 32000 + Math.random() * 40000);
    };
    timer = setTimeout(spawn, 9000 + Math.random() * 10000);
    return () => clearTimeout(timer);
  }, []);

  const remove = (id) => setList((l) => l.filter((x) => x !== id));

  return (
    <div data-testid="feathers-layer" aria-hidden style={{ pointerEvents: "none" }}>
      <AnimatePresence>
        {list.map((id) => (
          <Feather key={id} id={id} onDone={remove} />
        ))}
      </AnimatePresence>
    </div>
  );
}
